import {UserInfo} from './user-info';

export default {
    component: UserInfo
};
